module.exports = __webpack_public_path__ + "static/media/15.a8e4b2a3.jpg";